import { FC } from "react";

export const IconCheck: FC = () => (
  <svg viewBox="0 0 70 70">
    <path d="M26.474 70c-2.176 0-4.234-1.018-5.557-2.764L3.049 43.639C.725 40.57 1.33 36.2 4.399 33.875c3.074-2.326 7.441-1.717 9.766 1.35l11.752 15.518L55.474 3.285C57.509.02 61.806-.979 65.078 1.053c3.268 2.034 4.266 6.334 2.23 9.602l-34.916 56.06c-1.213 1.949-3.307 3.175-5.6 3.279-.107.004-.212.006-.318.006z" />
  </svg>
);
